/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateTicketTypeDto } from '../../models/create-ticket-type-dto';
import { TicketTypeDto } from '../../models/ticket-type-dto';

export interface CenterTicketTypeControllerCreate$Params {
  centerId: string;
      body: CreateTicketTypeDto
}

export function centerTicketTypeControllerCreate(http: HttpClient, rootUrl: string, params: CenterTicketTypeControllerCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<TicketTypeDto>> {
  const rb = new RequestBuilder(rootUrl, centerTicketTypeControllerCreate.PATH, 'post');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TicketTypeDto>;
    })
  );
}

centerTicketTypeControllerCreate.PATH = '/api/ticket-type/center';
